export interface EnumOptionDraft {
  id?: string;
  name: string;
  description: string;
}

export interface NamedEnumOption {
  id?: string;
  name: string;
  description: string | null;
  sortOrder: number;
}

/**
 * Drop unnamed rows and emit `null` for blank option descriptions so an
 * update can explicitly clear a previously stored description.
 */
export function toNamedEnumOptions(
  options: readonly EnumOptionDraft[],
): NamedEnumOption[] {
  return options
    .map((opt, idx) => ({
      ...(opt.id && { id: opt.id }),
      name: opt.name.trim(),
      description: opt.description.trim() || null,
      sortOrder: idx,
    }))
    .filter((opt) => opt.name.length > 0);
}
